const types = {
  SET_USER_NAME: 'SET_USER_NAME',
};

export default types;
